// Community Building Management APIs

/**
 * @function ApiClient#GetBuildingData
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetBuildingData(cid, options = {}) {
  return await this._get(`/community/${cid}/building_data`, options);
}

/**
 * @function ApiClient#UpdateBuildingData
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} buildingData
 * @param {any} images = []
 * @param {any} options = {}
 */
export async function UpdateBuildingData(cid, buildingData, images = [], options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(buildingData));

  for (const img of images) {
    formData.append("Image", img);
  }

  return await this._put(`/community/${cid}/building_data`, formData, options);
}
